import React from 'react';
import { Typography } from 'antd';
import clsx from 'clsx';
import Container from 'common/components/container.component';
import { RouteName } from 'config/constants/route.constants';
import { OrderTranscription } from 'config/constants/transcription.constant';
import { useNavigate } from 'react-router';
import { User } from 'store/models/user.model';
import PaymentActions from '../payment-actions.component';
import styles from './style.module.scss';

const { Title } = Typography;

type PurchaseAbortedResultProps = {
  user: User;
};

const PurchaseAbortedResult: React.FC<PurchaseAbortedResultProps> = ({ user }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <div className={styles['status-view-wrapper']}>
        <div className={clsx(styles['status-card'], styles['aborted'])}>
          <div className={styles['icon-container']}>
            <div className={styles['circle-icon']}>!</div>
          </div>
          <Title level={2} className={styles['status-title']}>
            {OrderTranscription.PURCHASE_ABORTED}
          </Title>
          <div className={styles['status-description']}>
            Estimado <strong>{user.name}</strong>, la compra ha sido cancelada.
          </div>
          <PaymentActions onRetryPurchase={() => navigate(RouteName.PURCHASE_CHECKOUT)} onGoHome={() => navigate(RouteName.HOME)} />
        </div>
      </div>
    </Container>
  );
};

export default PurchaseAbortedResult;
